// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39rUf","colBig":"styles_colBig__1Zx26","colSmall":"styles_colSmall__1tN40"};